import { createTheme } from "./createTheme";
export var lightTheme = createTheme({});